// eslint-disable-next-line react/no-unused-prop-types

import React from 'react';
import LEGACY_COLORS from '@/styles/legacyColors';

type IconProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  style?: object;
  width?: number;
  height?: number;
  // eslint-disable-next-line react/no-unused-prop-types
  color?: string;
};
export type Icon = (props: IconProps) => JSX.Element;

// https://react-svgr.com/playground

/**
 * ~~~~~~ IMPORTANT ~~~~~~
 * if the generator does not add a 'viewBox' prop to the <svg> element then add it yourself by taking the given width and height values:
 * <svg width={width || 20} height={height || 35} viewBox="0 0 20 35">.....</svg>
 *
 * by adding the 'viewBox' we can pass a custom width or height props
 * and the svg will maintain the aspect ratio instead of being cut off
 */

export function ContentCreationIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      width={18}
      height={18}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M7.691 3a5.229 5.229 0 0 0-.724 1.5H1.5v12h12v-5.467a5.229 5.229 0 0 0 1.5-.724V16.5a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 0 16.5v-12A1.5 1.5 0 0 1 1.5 3h6.191Zm3.832 3.477L8.25 5.25l3.273-1.227L12.75.75l1.227 3.273L17.25 5.25l-3.273 1.227L12.75 9.75l-1.227-3.273Zm-4.569 4.569L4.5 10.125l2.454-.92.921-2.455.92 2.454 2.455.921-2.454.92-.921 2.455-.92-2.454Z"
        fillRule="nonzero"
        fill={color || LEGACY_COLORS.GRAY}
      />
    </svg>
  );
}

export function SocialPostIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      width={27}
      height={17}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill="none" fillRule="evenodd" opacity={0.788}>
        <path d="M-1-5h28v24H-1z" />
        <path
          d="m3.278 11 1.414 1.414 4.707-4.707L4.692 3 3.278 4.414l2.293 2.293H0v2h5.571z"
          fill={color || LEGACY_COLORS.GRAY}
          fillRule="nonzero"
        />
        <path
          d="m21.674 13.971.35-3.148a2.033 2.033 0 0 0 1.312-.998l1.351.226a6.818 6.818 0 0 1-3.013 3.92m-6.795.142.48-1.201c.028.001.053.009.081.009a2.038 2.038 0 0 0 2.036-2.002l2.483-.829c.19.245.432.442.713.58l-.44 3.965a6.762 6.762 0 0 1-5.353-.522M11.36 8.16c0-.312.028-.615.069-.916l2.249 2.624a2.02 2.02 0 0 0-.278 1.012c0 .61.273 1.15.697 1.524l-.362.907a6.78 6.78 0 0 1-2.375-5.151m1.354-4.055 2.74.782a2.034 2.034 0 0 0 2.026 1.913c.314 0 .609-.078.875-.204l1.369 1.37a2.026 2.026 0 0 0-.2.835l-2.483.828a2.029 2.029 0 0 0-1.6-.79c-.26 0-.505.054-.733.141l-2.832-3.303-.059.05a6.787 6.787 0 0 1 .897-1.622m7.014-2.556-1.373 1.375a2.019 2.019 0 0 0-.875-.204c-.685 0-1.288.34-1.658.858l-2.067-.59a6.767 6.767 0 0 1 4.405-1.628c.54 0 1.064.07 1.568.19m3.808 2.46-1.614 2.826a2.052 2.052 0 0 0-.362-.036c-.314 0-.608.076-.875.204l-1.369-1.37c.127-.266.204-.56.204-.874 0-.315-.077-.609-.204-.875l1.827-1.827a6.83 6.83 0 0 1 2.393 1.953m1.396 4.701-1.368-.228a2.022 2.022 0 0 0-.464-.969l1.242-2.173c.393.86.618 1.812.618 2.818 0 .186-.013.37-.028.552M18.16.001C13.66 0 10 3.66 10 8.16c0 4.498 3.66 8.16 8.16 8.16s8.16-3.662 8.16-8.16c0-4.5-3.66-8.16-8.16-8.16"
          fill={color || LEGACY_COLORS.GRAY}
        />
      </g>
    </svg>
  );
}

export function CameraIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={17}
      style={style}
    >
      <g fill={color || LEGACY_COLORS.GRAY} fillRule="evenodd">
        <path d="M9 11.702a2.703 2.703 0 0 1-2.7-2.7c0-1.49 1.211-2.7 2.7-2.7s2.7 1.21 2.7 2.7c0 1.488-1.211 2.7-2.7 2.7m0-7.2a4.505 4.505 0 0 0-4.5 4.5c0 2.48 2.019 4.5 4.5 4.5s4.5-2.02 4.5-4.5c0-2.482-2.019-4.5-4.5-4.5" />
        <path d="M1.8 14.402v-9.9h4.082l1.8-2.7h2.636l1.8 2.7H16.2v9.9H1.8zm14.4-11.7h-3.118l-1.266-1.9a1.798 1.798 0 0 0-1.498-.8H7.683a1.8 1.8 0 0 0-1.498.8l-1.266 1.9H1.8c-.993 0-1.8.807-1.8 1.8v9.9c0 .991.807 1.8 1.8 1.8h14.4c.993 0 1.8-.809 1.8-1.8v-9.9c0-.993-.807-1.8-1.8-1.8z" />
      </g>
    </svg>
  );
}

export function MixedMediaIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      width={18}
      height={18}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M-1-.997h20.083v20.083H-1z" />
        <g fill={color || LEGACY_COLORS.GRAY} fillRule="nonzero">
          <path d="M6.531 8.206H2.347c-.924 0-1.673-.751-1.673-1.674V2.348c0-.922.75-1.674 1.673-1.674h4.184c.924 0 1.674.752 1.674 1.674v4.184c0 .923-.75 1.674-1.674 1.674ZM2.347 2.348v4.184H6.53l.002-4.184H2.347ZM15.736 8.206h-4.184c-.924 0-1.674-.751-1.674-1.674V2.348c0-.922.75-1.674 1.674-1.674h4.184c.924 0 1.674.752 1.674 1.674v4.184c0 .923-.75 1.674-1.674 1.674Zm-4.184-5.858v4.184h4.181l.003-4.184h-4.184ZM6.531 17.41H2.347c-.924 0-1.673-.75-1.673-1.673v-4.184c0-.922.75-1.674 1.673-1.674h4.184c.924 0 1.674.752 1.674 1.674v4.184c0 .923-.75 1.673-1.674 1.673Zm-4.184-5.857v4.184H6.53l.002-4.184H2.347ZM15.736 17.41h-4.184c-.924 0-1.674-.75-1.674-1.673v-4.184c0-.922.75-1.674 1.674-1.674h4.184c.924 0 1.674.752 1.674 1.674v4.184c0 .923-.75 1.673-1.674 1.673Zm-4.184-5.857v4.184h4.181l.003-4.184h-4.184Z" />
        </g>
      </g>
    </svg>
  );
}

export function BlogIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      style={style}
    >
      <g fill={color || LEGACY_COLORS.GRAY} fillRule="evenodd">
        <path d="M7.8 4H3v1.6h4.8zm0 3H3v1.6h4.8zm4.8 3H3v1.6h9.6z" />
        <path d="M14.398 14.4H1.6V1.6h12.8l-.002 12.8zM14.4 0H1.6C.718 0 0 .718 0 1.6v12.8c0 .882.718 1.6 1.6 1.6h12.8c.882 0 1.6-.718 1.6-1.6V1.6c0-.882-.718-1.6-1.6-1.6z" />
        <path d="M13.2 4H10v4.8h3.2z" />
      </g>
    </svg>
  );
}

export function VideoIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={16}
      style={style}
    >
      <g fill={color || LEGACY_COLORS.GRAY} fillRule="evenodd">
        <path d="M7.364 10.4 12.273 8l-4.91-2.4z" />
        <path d="M1.636 14.4V1.6h14.728l.001 12.8H1.636zM16.364 0H1.636C.734 0 0 .717 0 1.6v12.8c0 .882.734 1.6 1.636 1.6h14.728c.902 0 1.636-.718 1.636-1.6V1.6c0-.883-.734-1.6-1.636-1.6z" />
        <path d="M3.273 4h1.636V2.4H3.273zm4.909-1.6H6.545V4h1.637zm3.273 0H9.818V4h1.637zM13.09 4h1.637V2.4h-1.636zm-9.817 9.6h1.636V12H3.273zm3.272 0h1.637V12H6.545zm3.273 0h1.637V12H9.818zm3.272 0h1.637V12h-1.636z" />
      </g>
    </svg>
  );
}

export function InstagramPostIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      width={27}
      height={17}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill={color || LEGACY_COLORS.GRAY} fillRule="evenodd">
        <path d="M18.27 1.49c2.208 0 2.47.009 3.342.048.806.037 1.244.172 1.536.285.386.15.661.33.95.619.29.29.47.565.62.95.112.292.247.73.284 1.536.04.872.048 1.134.048 3.342s-.008 2.47-.048 3.342c-.037.806-.172 1.244-.285 1.536-.15.386-.33.661-.618.95-.29.29-.565.47-.951.62-.292.112-.73.247-1.536.284-.872.04-1.134.048-3.342.048s-2.47-.008-3.342-.048c-.806-.037-1.244-.172-1.535-.285a2.562 2.562 0 0 1-.951-.618 2.562 2.562 0 0 1-.619-.951c-.113-.292-.248-.73-.285-1.536-.04-.872-.048-1.134-.048-3.342s.009-2.47.048-3.342c.037-.806.172-1.244.285-1.535.15-.386.33-.662.619-.951.29-.29.565-.469.95-.619.292-.113.73-.248 1.536-.285.872-.04 1.134-.048 3.342-.048ZM14.86.05c-.88.04-1.481.18-2.007.384a4.054 4.054 0 0 0-1.465.954c-.46.46-.742.921-.954 1.465-.204.526-.344 1.127-.384 2.007-.04.882-.05 1.164-.05 3.41 0 2.246.01 2.528.05 3.41.04.88.18 1.481.384 2.007.212.544.494 1.005.954 1.465.46.46.921.743 1.465.954.526.205 1.127.344 2.007.384.882.04 1.164.05 3.41.05 2.246 0 2.528-.01 3.41-.05.88-.04 1.481-.18 2.007-.384a4.054 4.054 0 0 0 1.465-.954c.46-.46.743-.92.954-1.465.205-.526.344-1.127.384-2.007.04-.882.05-1.164.05-3.41 0-2.246-.01-2.528-.05-3.41-.04-.88-.18-1.481-.384-2.007a4.054 4.054 0 0 0-.954-1.465 4.054 4.054 0 0 0-1.465-.954C23.161.23 22.56.09 21.68.05 20.798.01 20.516 0 18.27 0c-2.246 0-2.528.01-3.41.05Z" />
        <path d="M18.247 4a4.247 4.247 0 1 0 0 8.494 4.247 4.247 0 0 0 0-8.494Zm0 7.004a2.757 2.757 0 1 1 0-5.514 2.757 2.757 0 0 1 0 5.514ZM22.985 3.992a.992.992 0 1 1-1.985 0 .992.992 0 0 1 1.985 0M3.278 12l1.414 1.414 4.707-4.707L4.692 4 3.278 5.414l2.293 2.293H0v2h5.571z" />
      </g>
    </svg>
  );
}

export function StoryPostIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      width={28}
      height={27}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h28v24H0z" />
        <g fill={color || LEGACY_COLORS.GRAY} fillRule="nonzero">
          <path d="M20.34 11.77h2.914v1.458H20.34v2.913h-1.457v-2.913H15.97V11.77h2.914V8.857h1.457v2.914Zm3.868 7.879a.728.728 0 1 1-.788-1.225 7.042 7.042 0 0 0-3.808-12.967.728.728 0 0 1 0-1.457 8.499 8.499 0 0 1 4.596 15.649Zm-8.322.489a.728.728 0 0 1 .639-1.31c1.414.69 2.983.88 4.492.572a.728.728 0 0 1 .292 1.427 8.464 8.464 0 0 1-5.423-.69Zm-4.467-5.37a.728.728 0 1 1 1.405-.389 7.037 7.037 0 0 0 1.883 3.173.728.728 0 0 1-1.015 1.046 8.494 8.494 0 0 1-2.273-3.83Zm.257-5.776a.728.728 0 1 1 1.331.59 6.99 6.99 0 0 0-.555 2.04.728.728 0 1 1-1.447-.166 8.447 8.447 0 0 1 .67-2.464Zm2.395-2.938a.728.728 0 0 1 .95 1.105c-.125.108-.247.22-.365.337a.728.728 0 0 1-1.025-1.035c.142-.14.289-.276.44-.407ZM4.278 16l1.414 1.414 4.707-4.707L5.692 8 4.278 9.414l2.293 2.293H1v2h5.571z" />
        </g>
      </g>
    </svg>
  );
}

export function PinterestPostIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      width={27}
      height={17}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill={color || LEGACY_COLORS.GRAY} fillRule="evenodd">
        <path d="M18.5 0a8.5 8.5 0 0 0-3.097 16.415c-.075-.673-.142-1.704.029-2.438.155-.664.997-4.225.997-4.225s-.255-.51-.255-1.262c0-1.182.685-2.064 1.538-2.064.726 0 1.076.544 1.076 1.197 0 .73-.464 1.82-.704 2.83-.2.846.424 1.536 1.258 1.536 1.511 0 2.673-1.593 2.673-3.893 0-2.035-1.463-3.458-3.55-3.458-2.42 0-3.839 1.814-3.839 3.69 0 .73.282 1.513.633 1.939.07.084.08.158.059.244l-.236.963c-.037.156-.124.189-.285.115-1.061-.495-1.725-2.047-1.725-3.294 0-2.68 1.948-5.143 5.616-5.143 2.948 0 5.24 2.101 5.24 4.909 0 2.93-1.847 5.287-4.41 5.287-.862 0-1.671-.448-1.948-.976 0 0-.427 1.623-.53 2.02-.192.739-.71 1.664-1.057 2.229.795.246 1.64.378 2.517.378A8.5 8.5 0 0 0 18.5 0M3.278 12l1.414 1.414 4.707-4.707L4.692 4 3.278 5.414l2.293 2.293H0v2h5.571z" />
      </g>
    </svg>
  );
}

export function YoutubePostIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      width={27}
      height={13}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill={color || LEGACY_COLORS.GRAY} fillRule="evenodd">
        <path d="M16.8 8.625v-5.1l4.417 2.55-4.417 2.55Zm9.845-6.642A2.13 2.13 0 0 0 25.142.48C23.816.125 18.5.125 18.5.125s-5.316 0-6.642.355a2.129 2.129 0 0 0-1.503 1.503C10 3.31 10 6.075 10 6.075s0 2.766.355 4.092a2.129 2.129 0 0 0 1.503 1.503c1.326.355 6.642.355 6.642.355s5.316 0 6.642-.355a2.13 2.13 0 0 0 1.503-1.503C27 8.84 27 6.075 27 6.075s0-2.766-.355-4.092ZM3.278 10l1.414 1.414 4.707-4.707L4.692 2 3.278 3.414l2.293 2.293H0v2h5.571z" />
      </g>
    </svg>
  );
}

export function FacebookPostIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      width={28}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill={color || LEGACY_COLORS.GRAY} fillRule="evenodd">
        <path d="M25.875 18.171a.704.704 0 0 1-.704.704h-3.249v-4.937h1.658l.248-1.925h-1.906v-1.228c0-.557.155-.937.954-.937h1.019V8.127a13.686 13.686 0 0 0-1.485-.076c-1.469 0-2.475.897-2.475 2.543v1.42h-1.661v1.924h1.661v4.937H13.83a.704.704 0 0 1-.704-.704V6.83c0-.389.315-.704.704-.704H25.17c.389 0 .704.315.704.704v11.342M4.139 15.648 5.493 17 10 12.5 5.493 8 4.139 9.352l2.195 2.192H1v1.912h5.334z" />
      </g>
    </svg>
  );
}

export function TiktokPostIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      width={25}
      height={17}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill={color || LEGACY_COLORS.GRAY} fillRule="nonzero">
        <path d="m3.278 12 1.414 1.414 4.707-4.707L4.692 4 3.278 5.414l2.293 2.293H0v2h5.571zM23.022 3.636c.754.372 1.49.485 1.853.446v2.899s-1.035-.042-1.803-.244c-1.07-.284-1.757-.72-1.757-.72s-.476-.312-.512-.333v5.989c0 .333-.089 1.166-.355 1.86-.349.908-.89 1.506-.989 1.627 0 0-.658.808-1.813 1.35-1.042.49-1.96.478-2.234.49 0 0-1.582.063-3.008-.897l-.007-.008a5.992 5.992 0 0 1-.423-.478 5.787 5.787 0 0 1-.804-1.453v-.003c-.109-.323-.329-1.083-.32-1.835l.003-.093c-.032.787.207 1.598.317 1.935v.003c.071.192.348.876.804 1.453.131.167.273.326.423.479a5.982 5.982 0 0 1-1.277-1.191 5.671 5.671 0 0 1-.8-1.446v-.007c-.114-.337-.352-1.152-.316-1.938.056-1.386.526-2.24.65-2.453a5.738 5.738 0 0 1 1.263-1.541 5.302 5.302 0 0 1 1.5-.886 5.269 5.269 0 0 1 1.06-.312 5.304 5.304 0 0 1 1.657-.025v.66l-.003-.001V9.26s-1.17-.387-2.11.297c-.653.507-1.002 1-1.105 1.882-.004.649.156 1.566 1.031 2.18.103.067.203.127.303.18.152.206.337.386.55.535.253.166.493.286.729.364l-.14-.051a3.286 3.286 0 0 1-.585-.313 2.307 2.307 0 0 1-.55-.531c.728.386 1.379.379 2.186.056.612-.244 1.07-.797 1.284-1.406.116-.328.13-.657.131-.994V0h2.948c-.003 0-.035.28.04.712h-.004c.089.521.33 1.265.978 1.999.26.276.551.524.867.73.11.07.22.135.338.195Z" />
      </g>
    </svg>
  );
}

export function TwitterPostIcon(props: IconProps) {
  const {style, color, width, height} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27 13"
      style={{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        enableBackground: 'new 0 0 27 13',
      }}
      xmlSpace="preserve"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color || LEGACY_COLORS.GRAY}
        d="m3.3 8 1.4 1.4 4.7-4.7L4.7 0 3.3 1.4l2.3 2.3H0v2h5.6z"
        transform="translate(0 2)"
      />
      <path
        d="M25 3.3v.4c0 4.2-3.2 9.1-9.1 9.1-1.7 0-3.4-.5-4.9-1.4h.8c1.4 0 2.8-.5 4-1.4-1.4 0-2.6-.9-3-2.2.5.1 1 .1 1.4-.1-1.5-.3-2.6-1.6-2.6-3.1.5.3 1 .4 1.5.4-1.4-.9-1.8-2.8-1-4.2 1.6 2 4 3.2 6.6 3.3-.3-1.1.1-2.3.9-3 1.3-1.2 3.3-1.1 4.5.1.7-.1 1.4-.4 2-.8-.2.7-.7 1.4-1.4 1.8.7-.1 1.3-.2 1.9-.5-.5.6-1 1.2-1.6 1.6z"
        fill={color || LEGACY_COLORS.GRAY}
      />
    </svg>
  );
}

export function Thumby(props: IconProps) {
  const {style, width, height} = props;
  return (
    <svg
      width={width || 58}
      height={height || 65}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path id="a" d="M57.349.711H0V65H57.35V.71z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(.5 -.71)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            d="M57.349 36.842a7.635 7.635 0 0 0-2.358-5.508 7.635 7.635 0 0 0 2.358-5.508c0-4.214-3.447-7.661-7.661-7.661H26.383c-.164 0-.326.015-.488.025l2.54-9.441C28.86 4.268 24.798.703 20.37.71c-4.43.007-6.735 2.93-8.04 8.065L7.838 25.48a27.206 27.206 0 0 0-.976 3.134L.164 54.55C-1.067 60.983 4.866 65 10.613 65h12.93c.63 0 1.242-.066 1.84-.173.47.109.956.173 1.457.173h20.267c3.543 0 6.443-2.9 6.443-6.443a6.404 6.404 0 0 0-1.628-4.26c2.208-1.024 3.753-3.26 3.753-5.843a6.431 6.431 0 0 0-2.29-4.911c2.358-1.31 3.964-3.826 3.964-6.701"
            fill="#07C98F"
            mask="url(#b)"
          />
        </g>
        <path
          d="M48.562 36.55S40.146 47.86 29.765 47.86c-10.382 0-18.797-11.312-18.797-11.312s8.415-11.312 18.797-11.312c10.381 0 18.797 11.312 18.797 11.312"
          fill="#FFF"
        />
        <path
          d="M34.308 36.55a4.543 4.543 0 1 1-9.086-.001 4.543 4.543 0 0 1 9.086 0"
          fill="#231F1F"
        />
      </g>
    </svg>
  );
}

export function PopularPaysLogo(props: IconProps) {
  const {style, width, height} = props;
  return (
    <svg
      width={width || 35}
      height={height || 35}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill="#07C98F" fillRule="evenodd">
        <path d="M0 0v35h10v-5H5V5h5V0zM25 0v5h5v15h-5v5h10V0z" />
      </g>
    </svg>
  );
}
export function PopularPaysLogoGreen(props: IconProps) {
  const {style, width, height} = props;
  return (
    <svg
      width={width || 35}
      height={height || 35}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 35 35"
      style={style}
    >
      <g
        id="Layout"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Homepage-Landing-Mobile-Opt1.0"
          transform="translate(-15.000000, -13.000000)"
          fill="#07C98F"
        >
          <g id="Masthead">
            <g id="logo-p-color" transform="translate(15.000000, 13.000000)">
              <polygon
                id="Fill-17"
                points="0 0 0 35 10 35 10 30.0001584 4.99972282 30.0001584 4.99972282 4.99984161 10 4.99984161 10 0"
              />
              <polygon
                id="Fill-18"
                points="25 0 25 4.99977826 29.9997228 4.99977826 29.9997228 19.9996674 25 19.9996674 25 25 35 25 35 0"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function PopularPaysBanner(props: IconProps) {
  const {style, width, height} = props;
  return (
    <svg
      width={width || 299}
      height={height || 73}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 299 73"
      {...props}
    >
      <path
        d="M0 .751v71.376h20.228V61.924H10.114v-50.97h10.114V.751H0ZM50.878.796v10.203h10.158v30.564H50.878V51.72h20.406V.796H50.878Z"
        fill="#07C98F"
      />
      <path
        d="M157.761 59.461c.038 0 .076-.01.104-.029.029-.028.048-.056.048-.094l.057-1.273a.33.33 0 0 0-.276-.341 2.816 2.816 0 0 0-2.971 1.32v-.827a.33.33 0 0 0-.332-.332h-1.054a.33.33 0 0 0-.332.332v7.842c0 .19.152.332.332.332h1.054a.33.33 0 0 0 .332-.332v-3.94c0-.901.199-1.566.598-1.984.579-.627 1.642-.77 2.44-.674ZM122.642 66.383a.33.33 0 0 1-.332-.332v-7.842a.33.33 0 0 1 .332-.332h1.054a.33.33 0 0 1 .332.332v7.842a.33.33 0 0 1-.332.332h-1.054Zm.522-10.272a1.173 1.173 0 0 1-1.168-1.167c0-.646.532-1.168 1.168-1.168a1.168 1.168 0 1 1 0 2.335ZM159.772 66.381a.33.33 0 0 1-.332-.332v-7.842a.33.33 0 0 1 .332-.332h1.054a.33.33 0 0 1 .332.332v7.842a.33.33 0 0 1-.332.332h-1.054ZM177.34 66.382a.306.306 0 0 1-.247-.114l-3.693-4.13v3.903a.33.33 0 0 1-.332.332h-1.054a.33.33 0 0 1-.332-.332V54.06a.33.33 0 0 1 .332-.333h1.054a.33.33 0 0 1 .332.333v7.347l3.408-3.427a.33.33 0 0 1 .237-.094h1.937c.057 0 .104.028.123.085a.132.132 0 0 1-.028.143l-3.74 3.636 4.091 4.395a.133.133 0 0 1 .029.142c-.019.048-.067.076-.124.076h-1.993v.02ZM143.079 66.383a.33.33 0 0 1-.333-.333v-4.68c0-1.234-.607-2.089-1.841-2.089-1.567 0-2.269 1.14-2.269 2.725v4.044a.33.33 0 0 1-.333.333h-1.053a.33.33 0 0 1-.333-.333V54.07a.33.33 0 0 1 .333-.333h1.053a.33.33 0 0 1 .333.332v4.947c.522-.921 1.651-1.358 2.724-1.358 1.851 0 3.105 1.168 3.105 3.266v5.126a.33.33 0 0 1-.333.333h-1.053ZM113.758 66.383a.33.33 0 0 1-.333-.333V54.07a.33.33 0 0 1 .333-.333h1.158a.33.33 0 0 1 .332.332v10.585h5.412a.33.33 0 0 1 .332.333v1.054a.33.33 0 0 1-.332.332h-6.902v.01ZM170.196 65.017a.33.33 0 0 1 .094.237c0 .085-.038.18-.104.237-.826.78-1.842 1.11-3.038 1.11-2.554 0-4.452-1.727-4.452-4.433 0-2.582 1.747-4.49 4.452-4.49 1.149 0 2.212.361 3.057 1.14a.357.357 0 0 1 .114.246c0 .095-.038.18-.114.247l-.75.684a.345.345 0 0 1-.446.009 3.01 3.01 0 0 0-1.928-.712c-1.67 0-2.553 1.348-2.553 2.905 0 1.51 1.025 2.782 2.639 2.782.665 0 1.31-.218 1.823-.684.076-.057.123-.114.247-.114.095 0 .18.038.237.095l.722.74ZM181.984 60.146c0-.456.465-.864 1.338-.864a2.4 2.4 0 0 1 1.576.617.344.344 0 0 0 .428.019l.759-.58a.334.334 0 0 0 .133-.227.355.355 0 0 0-.076-.256c-.636-.75-1.547-1.187-2.725-1.187-1.728 0-3.256.95-3.256 2.668 0 .806.38 1.718 1.642 2.155 1.291.446 2.943.446 2.943 1.509 0 .674-.844.997-1.633.997-.617 0-1.348-.275-1.86-.77a.346.346 0 0 0-.447-.018l-.721.598a.362.362 0 0 0-.123.237c-.01.095.019.18.085.247.722.817 1.785 1.339 3.047 1.339 1.823 0 3.485-.883 3.485-2.706-.01-3.341-4.595-1.974-4.595-3.778ZM149.109 63.829c-.01-.228-.019-.456-.019-.693v-3.732h1.946a.33.33 0 0 0 .332-.332v-.845a.33.33 0 0 0-.332-.332h-1.946v-2.013a.331.331 0 0 0-.333-.332h-1.053a.331.331 0 0 0-.333.333v2.012h-1.5a.33.33 0 0 0-.332.332v.845c0 .19.152.332.332.332h1.5v4.301c0 1.035.038 1.87.75 2.42.807.628 2.317.58 3.095.276a.328.328 0 0 0 .218-.313v-1.13a.137.137 0 0 0-.056-.114.145.145 0 0 0-.124-.019c-1.082.399-2.089.2-2.145-.996ZM133.389 57.877a.33.33 0 0 0-.332.332v.779c-.655-.864-1.823-1.32-2.886-1.32-2.649 0-4.329 1.975-4.329 4.471 0 2.507 1.832 4.367 4.329 4.367 1.12 0 2.25-.446 2.886-1.405 0 1.178.332 3.921-2.953 3.921a3.94 3.94 0 0 1-2.781-1.082.36.36 0 0 0-.257-.095.298.298 0 0 0-.237.124l-.684.854a.332.332 0 0 0 .048.465c1.016.864 2.184 1.348 3.95 1.348 2.686 0 4.642-1.718 4.642-4.376v-8.042a.33.33 0 0 0-.332-.332h-1.064v-.01Zm-3.028 6.996c-1.681 0-2.687-1.1-2.687-2.743 0-1.747 1.111-2.848 2.687-2.848 1.585 0 2.686 1.12 2.686 2.848 0 1.642-.997 2.743-2.686 2.743ZM160.304 56.11a1.173 1.173 0 0 1-1.167-1.166c0-.646.532-1.168 1.167-1.168.646 0 1.168.531 1.168 1.167a1.18 1.18 0 0 1-1.168 1.168ZM88.57 52.693h1.415v6.447h.037c.39-.456.836-.817 1.349-1.074a3.745 3.745 0 0 1 1.69-.38c.664 0 1.271.115 1.822.333.55.228 1.016.532 1.405.93.39.399.684.874.902 1.415.218.541.323 1.14.323 1.775 0 .637-.105 1.234-.323 1.776a4.435 4.435 0 0 1-.892 1.414c-.38.399-.826.712-1.348.93a4.092 4.092 0 0 1-1.662.333c-.76 0-1.424-.161-2.003-.494-.57-.332-.997-.74-1.263-1.224h-.038v1.5H88.57v-13.68Zm1.405 9.456c0 .446.066.864.209 1.243.142.38.341.713.607.997.266.285.58.504.95.675.37.16.778.246 1.243.246.456 0 .874-.085 1.244-.246.37-.162.684-.39.95-.674.266-.285.465-.618.607-.998.142-.38.21-.797.21-1.243 0-.447-.068-.864-.21-1.244a2.965 2.965 0 0 0-.607-.997 2.978 2.978 0 0 0-.95-.674 3.06 3.06 0 0 0-1.244-.247c-.455 0-.873.086-1.243.247-.37.162-.684.39-.95.674a2.965 2.965 0 0 0-.607.997c-.133.38-.21.797-.21 1.244ZM102.819 68.32c-.142.36-.294.693-.446.987-.152.294-.332.55-.541.76-.209.208-.465.37-.759.494-.295.113-.656.17-1.083.17-.209 0-.418-.01-.645-.038a2 2 0 0 1-.627-.18l.18-1.235c.143.057.295.096.456.115.162.019.342.028.542.028.455 0 .797-.124 1.015-.38.218-.256.408-.588.56-1.015l.579-1.595-3.512-8.535h1.652l2.629 6.645h.039l2.515-6.645h1.538l-4.092 10.424ZM284.094 36.252c2.114 1.788 4.701 2.554 7.215 2.554 3.462 0 6.923-1.97 6.923-5.545 0-6.201-8.563-5.362-8.563-7.551 0-.912 1.093-1.313 2.405-1.313 1.276 0 2.478.51 3.425 1.13l2.114-3.21c-1.312-1.058-3.608-1.933-5.903-1.933-3.498 0-6.778 2.116-6.778 5.508 0 5.691 8.563 4.743 8.563 7.406 0 .875-.984 1.495-2.259 1.495-1.785 0-3.644-.73-4.846-1.641l-2.296 3.1ZM271.882 46.517l12.081-25.705h-4.921l-5.03 10.933-5.509-10.933H263.4l8.152 15.966-4.59 9.739h4.92ZM256.744 20.749v1.532c-1.532-1.24-3.392-1.897-5.435-1.897-4.779 0-8.609 3.83-8.609 9.193 0 5.399 3.867 9.229 8.682 9.229 2.225 0 4.012-.766 5.362-1.897v1.532h4.378V20.75h-4.378Zm-9.302 8.828c0-2.846 2.08-4.889 4.597-4.889 1.677 0 3.173.73 4.341 2.08v5.654c-1.022 1.277-2.481 2.08-4.269 2.08-2.553 0-4.669-2.007-4.669-4.925ZM228.999 23.826v-6.464h3.959c2.051 0 2.95.434 3.526 1.12.504.577.792 1.263.792 2.094 0 .83-.288 1.553-.792 2.13-.576.686-1.475 1.12-3.526 1.12h-3.959Zm4.571 4.26c3.526 0 5.685-1.155 7.053-2.96.971-1.264 1.511-2.853 1.511-4.55 0-1.697-.54-3.25-1.511-4.514-1.368-1.805-3.527-2.96-7.053-2.96h-9.429v25.276h4.858V28.087h4.571ZM212.965 20.53a6.075 6.075 0 0 0-1.424-.146c-2.155 0-4.09.732-5.15 2.048V20.64h-4.565v17.737h4.748V27.223c1.132-1.755 2.995-2.523 4.748-2.523.693 0 1.168.036 1.643.11v-4.28ZM193.03 20.749v1.532c-1.532-1.24-3.392-1.897-5.436-1.897-4.778 0-8.608 3.83-8.608 9.193 0 5.399 3.866 9.229 8.682 9.229 2.225 0 4.012-.766 5.362-1.897v1.532h4.377V20.75h-4.377Zm-9.302 8.828c0-2.846 2.079-4.889 4.596-4.889 1.678 0 3.174.73 4.341 2.08v5.654c-1.021 1.277-2.48 2.08-4.268 2.08-2.553 0-4.669-2.007-4.669-4.925ZM175.915 12.672h-4.713v25.705h4.713V12.672ZM162.046 20.812v11.523c-.657.836-2.115 2.18-4.12 2.18-.912 0-1.933-.29-2.662-1.09-.547-.618-.875-1.417-.875-3.017v-9.596h-4.74v9.342c0 2.617.62 4.507 1.75 5.889 1.349 1.672 3.536 2.762 5.943 2.762a7.623 7.623 0 0 0 5.068-1.926v1.563h4.375v-17.63h-4.739ZM128.613 20.747v25.77h4.632v-9.4c1.247.98 2.886 1.597 4.881 1.597 4.703 0 8.48-3.811 8.48-9.183 0-5.336-3.741-9.147-8.408-9.147-1.996 0-3.813.653-5.309 1.887v-1.524h-4.276Zm13.361 8.784c0 2.903-2.066 4.9-4.56 4.9-1.746 0-3.171-.799-4.169-2.07v-5.625c1.14-1.343 2.601-2.069 4.24-2.069 2.459 0 4.489 2.033 4.489 4.864ZM111.822 29.613c0-2.663 1.77-4.924 4.515-4.924 2.746 0 4.516 2.261 4.516 4.924 0 2.663-1.77 4.888-4.516 4.888-2.745 0-4.515-2.225-4.515-4.888Zm-4.696 0c0 5.107 3.938 9.193 9.211 9.193 5.274 0 9.211-4.086 9.211-9.193 0-5.107-3.937-9.229-9.211-9.229-5.273 0-9.211 4.122-9.211 9.23ZM93.428 23.826v-6.464h3.959c2.051 0 2.951.434 3.526 1.12.504.577.792 1.263.792 2.094 0 .83-.288 1.553-.792 2.13-.575.686-1.475 1.12-3.526 1.12h-3.959Zm4.57 4.26c3.527 0 5.686-1.155 7.054-2.96.972-1.264 1.511-2.853 1.511-4.55 0-1.697-.539-3.25-1.511-4.514-1.368-1.805-3.527-2.96-7.054-2.96H88.57v25.276h4.858V28.087h4.57Z"
        fill="#1F1F24"
      />
    </svg>
  );
}

export function ValidationErrorIcon(props: IconProps) {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 25 25"
      style={{
        enableBackground: 'new 0 0 25 25',
      }}
      xmlSpace="preserve"
      {...props}
    >
      <g id="Styles">
        <g id="Patterns" transform="translate(-1636 -284)">
          <g
            id="Form_x2F_Input-_x28_Error_x29_"
            transform="translate(1370 245)"
          >
            <g id="Error-blip" transform="translate(266 39)">
              <path id="bg" fill="#ff5151" d="M0 0h25v25H0z" />
            </g>
          </g>
        </g>
      </g>
      <path d="M11.2 5h2.5v8.8h-2.5z" fill="#fff" />
      <circle cx={12.5} cy={17.5} r={1.6} fill="#fff" />
    </svg>
  );
}

export function CogWheel(props: IconProps) {
  const {color, width, height} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 24}
      height={height || 24}
      viewBox="0 0 72 72"
      {...props}
    >
      <path
        fill={color || LEGACY_COLORS.GRAY}
        d="M32 6.9c0 3.7-.3 4-3.7 5.2-2.1.6-4.4 1.6-5.1 2.2-.9.7-1.9.4-3.5-1-3.7-3.3-4.3-3.3-7.1-.4l-2.7 2.8 2.7 3.2c1.8 2.2 2.3 3.5 1.6 4.4-.5.6-1.5 2.9-2.1 4.9-1.2 3.5-1.5 3.8-5.2 3.8C3 32 3 32 3 36s0 4 3.9 4c3.7 0 4 .3 5.2 3.7.6 2.1 1.6 4.4 2.1 5 .7.9.2 2.2-1.6 4.4l-2.7 3.2 2.7 2.8c2.8 2.9 3.4 2.9 7.1-.4 1.6-1.4 2.6-1.7 3.5-1 .7.6 3 1.6 5.1 2.2 3.4 1.2 3.7 1.5 3.7 5.2 0 3.9 0 3.9 4 3.9s4 0 4-3.9c0-3.7.3-4 3.8-5.2 2-.6 4.3-1.6 4.9-2.1.9-.7 2.2-.2 4.4 1.6l3.2 2.7 2.8-2.7c2.9-2.8 2.9-3.4-.4-7.1-1.4-1.6-1.7-2.6-1-3.5.6-.7 1.6-3 2.2-5.1 1.2-3.4 1.5-3.7 5.2-3.7 3.9 0 3.9 0 3.9-4s0-4-3.9-4c-3.7 0-4-.3-5.2-3.8-.6-2-1.6-4.3-2.1-4.9-.7-.9-.2-2.2 1.6-4.4l2.7-3.2-2.7-2.8c-2.8-2.9-3.4-2.9-7.1.4-1.6 1.4-2.6 1.7-3.5 1-.7-.6-3-1.6-5-2.2-3.5-1.2-3.8-1.5-3.8-5.2C40 3 40 3 36 3s-4 0-4 3.9zm12 15.2C54.5 28 54.5 44 44 49.9c-10.7 6-24-1.7-24-13.9 0-12.2 13.3-19.9 24-13.9z"
      />
    </svg>
  );
}

export function Lightning(props: IconProps) {
  const {color, width, height} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 23}
      height={height || 23}
      viewBox="0 0 23 23"
      {...props}
    >
      <g data-name="Layer">
        <clipPath id="a">
          <path transform="matrix(1 0 0 -1 0 23)" d="M0 23h23V0H0Z" />
        </clipPath>
        <g clipPath="url(#a)">
          <path
            d="M5.843 11.5h4.507c.634 0 1.15.516 1.15 1.15v5.923l5.657-7.073H12.65a1.15 1.15 0 0 1-1.15-1.15V4.427ZM10.35 23a1.15 1.15 0 0 1-1.15-1.149V13.8H3.45a1.15 1.15 0 0 1-.897-1.869l9.2-11.5a1.15 1.15 0 0 1 2.047.719V9.2h5.75a1.15 1.15 0 0 1 .896 1.869l-9.2 11.5a1.144 1.144 0 0 1-.896.431"
            fill={color || LEGACY_COLORS.GRAY}
          />
        </g>
      </g>
    </svg>
  );
}

export function Refresh(props: IconProps) {
  const {color, width, height} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 22}
      height={height || 22}
      viewBox="0 0 22 22"
      {...props}
    >
      <clipPath id="a">
        <path
          transform="matrix(1 0 0 -1 0 22)"
          d="M4.642 17.358A8.907 8.907 0 0 0 11 20c4.963 0 9-4.038 9-9h2c0 6.065-4.935 11-11 11a10.89 10.89 0 0 1-7.771-3.229L1 21v-6h6l-2.358 2.358Z"
        />
      </clipPath>
      <g clipPath="url(#a)">
        <path d="M-4-5h31v21H-4Z" fill={color || LEGACY_COLORS.GRAY} />
      </g>
      <clipPath id="b">
        <path
          transform="matrix(1 0 0 -1 0 22)"
          d="M17.357 4.642A8.9 8.9 0 0 0 11 2c-4.963 0-9 4.038-9 9H0C0 4.935 4.935 0 11 0c2.967 0 5.721 1.167 7.771 3.229L21 1v6h-6l2.357-2.358Z"
        />
      </clipPath>
      <g clipPath="url(#b)">
        <path d="M-5 6h31v21H-5Z" fill={color || LEGACY_COLORS.GRAY} />
      </g>
      <clipPath id="c">
        <path
          transform="matrix(1 0 0 -1 0 22)"
          d="M7 11c0-2.206 1.795-4 4-4s4 1.794 4 4-1.795 4-4 4-4-1.794-4-4Zm6 0c0-1.103-.896-2-2-2s-2 .897-2 2 .896 2 2 2 2-.897 2-2Z"
        />
      </clipPath>
      <g clipPath="url(#c)">
        <path d="M2 2h18v18H2Z" fill={color || LEGACY_COLORS.GRAY} />
      </g>
    </svg>
  );
}

export function Folder(props: IconProps) {
  const {color, width, height} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 17}
      height={height || 22}
      viewBox="0 0 17 22"
      {...props}
    >
      <g
        strokeWidth={2}
        strokeMiterlimit={10}
        fill="none"
        stroke={color || LEGACY_COLORS.GRAY}
      >
        <path d="M1.07 8.007A.92.92 0 0 1 2 7h12.96c.556 0 .974.45.934 1.007l-.86 11.986c-.04.556-.518 1.007-1.066 1.007H3.028C2.478 21 2 20.55 1.96 19.993L1.07 8.007Z" />
        <path strokeLinecap="round" d="M4.5 1h8M6.5 12h4M6.5 15h2M2.5 4h12" />
      </g>
    </svg>
  );
}

export function Support(props: IconProps) {
  const {color, width, height} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 26}
      height={height || 26}
      viewBox="0 0 26 26"
      {...props}
    >
      <clipPath id="a">
        <path
          transform="matrix(1 0 0 -1 0 26)"
          d="M13 7.433a1.042 1.042 0 1 1 0 2.083 1.042 1.042 0 0 1 0-2.083Z"
          fillRule="evenodd"
        />
      </clipPath>
      <g clipPath="url(#a)">
        <path
          d="M6.958 11.484h12.084v12.083H6.958Z"
          fill={color || LEGACY_COLORS.GRAY}
        />
      </g>
      <clipPath id="b">
        <path
          transform="matrix(1 0 0 -1 0 26)"
          d="M13 11.139a3.743 3.743 0 1 1-3.743 3.743h2.223a1.52 1.52 0 1 0 1.52-1.52v-2.223Z"
        />
      </clipPath>
      <g clipPath="url(#b)">
        <path
          d="M4.257 2.376h17.486V19.86H4.257Z"
          fill={color || LEGACY_COLORS.GRAY}
        />
      </g>
      <clipPath id="c">
        <path
          transform="matrix(1 0 0 -1 0 26)"
          d="M11.889 13.361v-3.264h2.222v3.264H11.89Z"
        />
      </clipPath>
      <g clipPath="url(#c)">
        <path
          d="M6.889 7.639H19.11v13.264H6.89Z"
          fill={color || LEGACY_COLORS.GRAY}
        />
      </g>
      <clipPath id="d">
        <path
          transform="matrix(1 0 0 -1 0 26)"
          d="M13 3C7.477 3 3 7.477 3 13s4.477 10 10 10 10-4.477 10-10S18.523 3 13 3Zm0 2.222a7.778 7.778 0 1 1 0 15.556 7.778 7.778 0 0 1 0-15.556Z"
        />
      </clipPath>
      <g clipPath="url(#d)">
        <path d="M-2-2h30v30H-2Z" fill={color || LEGACY_COLORS.GRAY} />
      </g>
    </svg>
  );
}

export function Logout(props: IconProps) {
  const {color, width, height} = props;
  return (
    <svg
      width={width || 25}
      height={height || 30}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m13.46 6.548-.944.945 1.532 1.531h-5.75v1.336h5.75l-1.532 1.532.945.944 3.144-3.144-3.144-3.144Z"
        fill={color || LEGACY_COLORS.GRAY}
      />
      <path
        d="M3.846 15.154V4.23h6.923v1.994h1.539V4.159c0-.803-.622-1.467-1.42-1.467H3.728c-.794 0-1.42.662-1.42 1.457v11.086c0 .796.626 1.457 1.42 1.457h7.162c.793 0 1.419-.66 1.419-1.454v-2.089h-1.539v2.005H3.846Z"
        fill={color || LEGACY_COLORS.GRAY}
      />
    </svg>
  );
}

export function User(props: IconProps) {
  const {color, width, height} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 17}
      height={height || 22}
      viewBox="0 0 17 22"
      {...props}
    >
      <path
        strokeWidth={2}
        strokeMiterlimit={10}
        fill="none"
        stroke={color || LEGACY_COLORS.GRAY}
        d="M8.5 10a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
      />
      <clipPath id="a">
        <path
          transform="matrix(1 0 0 -1 0 22)"
          d="M-10 20h36.75v-30H-10ZM14.75 2c0 3.314-2.854 6-6.375 6C4.855 8 2 5.314 2 2h12.75Z"
          fillRule="evenodd"
        />
      </clipPath>
      <g clipPath="url(#a)">
        <path
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          stroke={color || LEGACY_COLORS.GRAY}
          d="M14.75 20c0-3.314-2.854-6-6.375-6C4.855 14 2 16.686 2 20h12.75Z"
        />
      </g>
    </svg>
  );
}

export function AccountIcon(props: IconProps) {
  return (
    <svg
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="a" d="M0 0h172v1024H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-24 -804)">
          <use fill="#FFF" xlinkHref="#a" />
          <use fill="#000" xlinkHref="#a" />
        </g>
        <path d="M-24-12h172v48H-24z" />
        <path d="M0 0h24v24H0z" />
        <path
          d="M5.023 16.856A8.454 8.454 0 0 1 3.632 13.5H1.5A.5.5 0 0 1 1 13v-2a.5.5 0 0 1 .5-.5h2.132c.219-1.23.703-2.37 1.39-3.356L3.516 5.636a.5.5 0 0 1 0-.707l1.414-1.414a.5.5 0 0 1 .707 0l1.508 1.508A8.454 8.454 0 0 1 10.5 3.632V1.5A.5.5 0 0 1 11 1h2a.5.5 0 0 1 .5.5v2.132c1.23.219 2.37.703 3.356 1.39l1.508-1.507a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1 0 .707l-1.508 1.508a8.454 8.454 0 0 1 1.391 3.356H22.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2.132a8.454 8.454 0 0 1-1.39 3.356l1.507 1.508a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 0 1-.707 0l-1.508-1.508a8.454 8.454 0 0 1-3.356 1.391V22.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.132a8.454 8.454 0 0 1-3.356-1.39l-1.508 1.507a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 0-.707l1.508-1.508Zm6.977.85a5.706 5.706 0 1 0 0-11.412 5.706 5.706 0 0 0 0 11.412Z"
          fill={LEGACY_COLORS.GRAY}
        />
      </g>
    </svg>
  );
}

export function LightningIcon(props: IconProps) {
  const {color, width, height} = props;
  return (
    <svg
      width={width || 24}
      height={height || 24}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M6.466 11.25h4.408c.623 0 1.125.504 1.125 1.125v5.793l5.535-6.918h-4.41A1.125 1.125 0 0 1 12 10.125V4.332L6.466 11.25Zm4.408 11.25a1.124 1.124 0 0 1-1.125-1.125V13.5H4.124a1.127 1.127 0 0 1-.877-1.828l9-11.25a1.124 1.124 0 0 1 2.002.703V9h5.625c.434 0 .827.248 1.015.638.187.389.134.851-.136 1.19l-9 11.25a1.123 1.123 0 0 1-.879.422Z"
        fill={color || LEGACY_COLORS.GRAY}
        fillRule="evenodd"
      />
    </svg>
  );
}
export function InfiniteCircleArrowsIcon(props: IconProps) {
  const {color, width, height} = props;
  return (
    <svg
      width={width || 22}
      height={height || 22}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M-1-.999h24v24H-1z" />
        <g fill={color || LEGACY_COLORS.GRAY} fillRule="nonzero">
          <path d="M4.642 4.642A8.907 8.907 0 0 1 11 2c4.963 0 9 4.038 9 9h2c0-6.065-4.935-11-11-11a10.89 10.89 0 0 0-7.771 3.229L1 1v6h6L4.642 4.642ZM17.357 17.358A8.9 8.9 0 0 1 11 20c-4.963 0-9-4.038-9-9H0c0 6.065 4.935 11 11 11 2.967 0 5.721-1.167 7.771-3.229L21 21v-6h-6l2.357 2.358Z" />
          <path d="M7 11c0 2.206 1.795 4 4 4s4-1.794 4-4-1.795-4-4-4-4 1.794-4 4Zm6 0c0 1.103-.896 2-2 2s-2-.897-2-2 .896-2 2-2 2 .897 2 2Z" />
        </g>
      </g>
    </svg>
  );
}

export function QuestionMarkOutlineIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      style={{
        enableBackground: 'new 0 0 20 20',
      }}
      xmlSpace="preserve"
      {...props}
    >
      <g transform="translate(49 266)">
        <g transform="translate(5.5 3.774)">
          <circle fill={LEGACY_COLORS.GRAY} cx={-44.5} cy={-255.7} r={0.9} />
          <path
            fill="none"
            stroke={LEGACY_COLORS.GRAY}
            strokeWidth={2}
            d="M-44.5-259.1c1.3 0 2.4-1.1 2.4-2.4s-1.1-2.3-2.4-2.3-2.4 1-2.4 2.3"
          />
          <path
            strokeLinecap="square"
            stroke={LEGACY_COLORS.GRAY}
            strokeWidth={2}
            d="M-44.5-259.1v.9"
          />
        </g>
        <circle
          fill="none"
          stroke={LEGACY_COLORS.GRAY}
          strokeWidth={2}
          cx={-39}
          cy={-256}
          r={8}
        />
      </g>
    </svg>
  );
}
export function XGrayIcon(props: IconProps) {
  const {color, width, height} = props;

  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Styles"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Patterns/Gig-Status-Icons"
          transform="translate(-63.000000, -651.000000)"
          fill="#a5a5a5"
        >
          <g id="closing-cross" transform="translate(63.000000, 651.000000)">
            <path
              d="M19.5043768,0.48770321 C18.8474364,-0.162567737 17.7853272,-0.162567737 17.1283868,0.48770321 L9.96206753,7.65735723 L2.89912464,0.587744894 C2.24718633,-0.0625260525 1.1900792,-0.0625260525 0.541475615,0.587744894 C-0.110462693,1.23801584 -0.110462693,2.30512714 0.541475615,2.95539808 L7.60441851,10.0083368 L0.491454773,17.12797 C-0.163818258,17.7782409 -0.163818258,18.8453522 0.491454773,19.5122968 C1.14839516,20.1625677 2.21217174,20.1625677 2.86911213,19.5122968 L9.98207586,12.3926636 L17.0450188,19.4622759 C17.6969571,20.1125469 18.7540642,20.1125469 19.4043351,19.4622759 C20.0562734,18.812005 20.0562734,17.7448937 19.4043351,17.0946228 L12.3397249,10.041684 L19.5043768,2.87203001 C20.1596499,2.20508545 20.1596499,1.15464777 19.5043768,0.48770321 L19.5043768,0.48770321 Z"
              id="path"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function CheckGreen(props: IconProps) {
  const {color, width, height} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      style={{
        enableBackground: 'new 0 0 25 25',
      }}
      xmlSpace="preserve"
      {...props}
    >
      <path
        fill={color || '#07C98F'}
        d="m9.4 21-6.1-6.1 2.2-2.2 3.8 3.8L20.7 4 23 6.1z"
      />
    </svg>
  );
}

export function SyncWhiteIcon(props: IconProps) {
  const {style, width, height} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        enableBackground: 'new 0 0 24 24',
      }}
      xmlSpace="preserve"
      width={width || 20}
      height={height || 20}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill="#fff"
        d="M6.351 6.351A7.939 7.939 0 0 1 12 4c4.411 0 8 3.589 8 8h2c0-5.515-4.486-10-10-10a9.928 9.928 0 0 0-7.062 2.938L3 3v6h6L6.351 6.351zM17.649 17.649A7.937 7.937 0 0 1 12 20c-4.411 0-8-3.589-8-8H2c0 5.515 4.486 10 10 10a9.93 9.93 0 0 0 7.063-2.938L21 21v-6h-6l2.649 2.649z"
      />
    </svg>
  );
}

export function WhiteXIcon(props: IconProps) {
  const {style, width, height} = props;
  return (
    <svg
      width={width || 20}
      height={height || 20}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.504.488a1.69 1.69 0 0 0-2.376 0l-7.166 7.17L2.9.587a1.669 1.669 0 0 0-2.358 0 1.678 1.678 0 0 0 0 2.367l7.063 7.053-7.113 7.12a1.692 1.692 0 0 0 0 2.384c.657.65 1.721.65 2.378 0l7.113-7.12 7.063 7.07a1.67 1.67 0 1 0 2.36-2.367l-7.065-7.053 7.164-7.17a1.692 1.692 0 0 0 0-2.384Z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function InstagramSoloIcon(props: IconProps) {
  const {style, width = 16, height = 16} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99949 1.44154C10.1356 1.44154 10.3886 1.44967 11.2322 1.48816C12.0122 1.52376 12.4358 1.65409 12.7177 1.76361C13.0911 1.90874 13.3576 2.08213 13.6375 2.36206C13.9175 2.64199 14.0909 2.90852 14.236 3.28191C14.3455 3.56384 14.4758 3.98744 14.5114 4.7674C14.5499 5.61101 14.5581 5.86401 14.5581 8.00012C14.5581 10.1362 14.5499 10.3892 14.5114 11.2328C14.4758 12.0128 14.3455 12.4364 14.236 12.7183C14.0909 13.0917 13.9175 13.3583 13.6375 13.6382C13.3576 13.9181 13.0911 14.0915 12.7177 14.2366C12.4358 14.3462 12.0122 14.4765 11.2322 14.5121C10.3887 14.5506 10.1357 14.5587 7.99949 14.5587C5.86325 14.5587 5.61024 14.5506 4.7668 14.5121C3.9868 14.4765 3.56321 14.3462 3.28131 14.2366C2.90789 14.0915 2.64136 13.9181 2.36142 13.6382C2.08149 13.3583 1.9081 13.0917 1.76301 12.7183C1.65345 12.4364 1.52312 12.0128 1.48752 11.2328C1.44904 10.3892 1.44091 10.1362 1.44091 8.00012C1.44091 5.86401 1.44904 5.61101 1.48752 4.76743C1.52312 3.98744 1.65345 3.56384 1.76301 3.28191C1.9081 2.90852 2.08149 2.64199 2.36142 2.36206C2.64136 2.08213 2.90789 1.90874 3.28131 1.76361C3.56321 1.65409 3.9868 1.52376 4.76677 1.48816C5.61037 1.44967 5.86337 1.44154 7.99949 1.44154ZM4.70163 0.0481424C3.85009 0.087012 3.26857 0.22223 2.75968 0.420008C2.2336 0.624454 1.78746 0.898002 1.34272 1.34275C0.89797 1.78749 0.624422 2.23364 0.419976 2.75971C0.222198 3.2686 0.0869803 3.85012 0.0481107 4.70167C0.00917754 5.55492 0 5.82736 0 8.00006C0 10.1728 0.00917754 10.4452 0.0481107 11.2984C0.0869803 12.15 0.222198 12.7315 0.419976 13.2404C0.624422 13.7664 0.89797 14.2126 1.34272 14.6574C1.78746 15.1021 2.2336 15.3757 2.75968 15.5801C3.26857 15.7779 3.85009 15.9131 4.70163 15.952C5.55492 15.9909 5.82733 16.0001 8.00002 16.0001C10.1727 16.0001 10.4452 15.9909 11.2984 15.952C12.15 15.9131 12.7315 15.7779 13.2404 15.5801C13.7664 15.3757 14.2126 15.1021 14.6573 14.6574C15.1021 14.2126 15.3756 13.7665 15.5801 13.2404C15.7779 12.7315 15.9131 12.15 15.9519 11.2984C15.9909 10.4452 16.0001 10.1728 16.0001 8.00006C16.0001 5.82736 15.9909 5.55492 15.9519 4.70167C15.9131 3.85012 15.7779 3.2686 15.5801 2.75971C15.3756 2.23364 15.1021 1.78749 14.6573 1.34275C14.2126 0.898002 13.7664 0.624454 13.2404 0.420008C12.7315 0.22223 12.15 0.087012 11.2984 0.0481424C10.4452 0.0092093 10.1727 0 8.00002 0C5.82733 0 5.55492 0.0092093 4.70163 0.0481424Z"
        fill={LEGACY_COLORS.GRAY}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97728 3.86945C5.70843 3.86945 3.86914 5.70873 3.86914 7.97759C3.86914 10.2464 5.70843 12.0857 7.97728 12.0857C10.2461 12.0857 12.0854 10.2464 12.0854 7.97759C12.0854 5.70873 10.2461 3.86945 7.97728 3.86945ZM7.9767 10.6443C6.50395 10.6443 5.31001 9.45032 5.31001 7.97756C5.31001 6.5048 6.50395 5.31086 7.9767 5.31086C9.44946 5.31086 10.6434 6.5048 10.6434 7.97756C10.6434 9.45032 9.44946 10.6443 7.9767 10.6443Z"
        fill={LEGACY_COLORS.GRAY}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5604 3.86197C12.5604 4.39217 12.1306 4.82199 11.6004 4.82199C11.0702 4.82199 10.6404 4.39217 10.6404 3.86197C10.6404 3.33177 11.0702 2.90198 11.6004 2.90198C12.1306 2.90198 12.5604 3.33177 12.5604 3.86197Z"
        fill={LEGACY_COLORS.GRAY}
      />
    </svg>
  );
}

export function YouTubeSoloIcon(props: IconProps) {
  const {style, width = 23, height = 16} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5139 2.5C22.2505 1.51 21.4707 0.74 20.4883 0.48C18.6957 2.98023e-08 11.4949 0 11.4949 0C11.4949 0 4.30427 2.98023e-08 2.51167 0.48C1.52928 0.74 0.74945 1.51 0.476002 2.5C-3.01829e-08 4.28 0 8 0 8C0 8 -3.01829e-08 11.72 0.476002 13.5C0.74945 14.49 1.52928 15.26 2.51167 15.52C4.30427 16 11.4949 16 11.4949 16C11.4949 16 18.6957 16 20.4883 15.52C21.4707 15.26 22.2505 14.49 22.5139 13.5C23 11.72 23 8 23 8C23 8 23 4.28 22.5139 2.5ZM9.14531 11.38V4.62L15.1612 8L9.14531 11.38Z"
        fill={LEGACY_COLORS.GRAY}
      />
    </svg>
  );
}

export function TikTokSoloIcon(props: IconProps) {
  const {style, width = 16, height = 16} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.42982 0C9.44206 0 10.3937 0 11.3454 0C11.7001 2.42305 13.2401 3.76412 16 4.01556C16 4.86135 16 5.69951 16 6.58339C14.3043 6.57577 12.8075 6.11859 11.3887 5.21185C11.3887 5.39472 11.3887 5.51664 11.3887 5.63855C11.3887 7.52061 11.4492 9.41029 11.38 11.2847C11.3022 13.6621 9.21712 15.6203 6.55242 15.948C3.86176 16.2832 1.31818 14.9726 0.357847 12.7629C-0.89664 9.86747 1.28357 6.59101 4.77018 6.14907C5.26332 6.08811 5.76512 6.09573 6.26691 6.10335C6.37073 6.10335 6.56107 6.24051 6.56972 6.32432C6.58702 7.13201 6.57837 7.93969 6.57837 8.77786C5.80838 8.58736 5.09894 8.63308 4.42411 8.96073C3.2648 9.5322 2.7457 10.7133 3.17828 11.8029C3.60221 12.9001 4.8913 13.563 6.1977 13.3725C7.46949 13.182 8.40387 12.2067 8.41252 11.018C8.42982 8.88453 8.42982 6.75102 8.42982 4.61752C8.43847 3.09358 8.42982 1.56965 8.42982 0Z"
        fill={LEGACY_COLORS.GRAY}
      />
    </svg>
  );
}

export function PinterestSoloIcon(props: IconProps) {
  const {style, width = 13, height = 16} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5.74276C0 5.0709 0.141487 4.40385 0.426069 3.74319C0.710652 3.08253 1.11743 2.46827 1.648 1.90359C2.17858 1.33891 2.87476 0.87981 3.73816 0.527886C4.60155 0.175962 5.5582 0 6.6081 0C8.31237 0 9.71117 0.523087 10.8045 1.56766C11.8978 2.61224 12.4444 3.84397 12.4444 5.26286C12.4444 7.08647 11.9814 8.59334 11.0537 9.78189C10.126 10.9704 8.92817 11.5655 7.46024 11.5655C6.97789 11.5655 6.52449 11.4535 6.10164 11.2296C5.67878 11.0056 5.38134 10.7337 5.2093 10.4137L4.56618 12.9412C4.51312 13.1444 4.44238 13.3491 4.35716 13.5571C4.27195 13.765 4.17709 13.965 4.0758 14.1569C3.9745 14.3489 3.8716 14.5297 3.77031 14.7008C3.66902 14.872 3.56612 15.032 3.46483 15.1807C3.36354 15.3295 3.27511 15.4559 3.19954 15.5566C3.12397 15.6574 3.05484 15.7454 2.99053 15.8206L2.89406 15.9486C2.8619 15.9917 2.81849 16.0077 2.76543 15.9965C2.71237 15.9853 2.68022 15.9534 2.66896 15.9006C2.66896 15.8894 2.66092 15.8158 2.64485 15.6766C2.62877 15.5374 2.61269 15.3919 2.59661 15.2367C2.58053 15.0815 2.56446 14.8816 2.54838 14.6368C2.5323 14.3921 2.52748 14.1537 2.5323 13.925C2.53712 13.6962 2.5532 13.4419 2.58053 13.1652C2.60787 12.8884 2.64806 12.6325 2.70112 12.3973C2.81849 11.8966 3.21562 10.2266 3.8909 7.3904C3.80568 7.21924 3.73494 7.01448 3.68188 6.77454C3.62883 6.53459 3.60149 6.33943 3.60149 6.19066L3.58541 5.95071C3.58541 5.26766 3.75906 4.69978 4.10795 4.24708C4.45685 3.79438 4.87649 3.56723 5.37008 3.56723C5.76721 3.56723 6.0743 3.6984 6.29457 3.95914C6.51484 4.21989 6.62417 4.54782 6.62417 4.94293C6.62417 5.18768 6.57916 5.49001 6.48751 5.84674C6.39587 6.20346 6.27528 6.61457 6.12575 7.07847C5.97623 7.54237 5.8685 7.91829 5.80419 8.20623C5.69647 8.68612 5.79133 9.10203 6.08556 9.45396C6.37979 9.80588 6.7737 9.98184 7.2673 9.98184C8.11461 9.98184 8.81401 9.50515 9.36549 8.55015C9.91697 7.59516 10.1935 6.44181 10.1935 5.0869C10.1935 4.05192 9.85587 3.20731 9.18059 2.55145C8.50531 1.89559 7.56153 1.56766 6.35085 1.56766C5.00029 1.56766 3.90376 1.99957 3.06288 2.86338C2.22199 3.72719 1.80075 4.76217 1.80075 5.96671C1.80075 6.68176 2.00494 7.28323 2.41171 7.77432C2.55159 7.93428 2.5934 8.10545 2.54034 8.28621C2.51944 8.339 2.48728 8.46217 2.44387 8.65413C2.40046 8.84609 2.3683 8.96926 2.3474 9.02205C2.3265 9.13882 2.27183 9.21721 2.18662 9.254C2.10141 9.29079 2.00494 9.28919 1.89722 9.246C1.26535 8.99006 0.791042 8.55015 0.474304 7.92629C0.157565 7.30242 0 6.57458 0 5.74276Z"
        fill={LEGACY_COLORS.GRAY}
      />
    </svg>
  );
}

export function FacebookSoloIcon(props: IconProps) {
  const {style, width = 16, height = 16} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2326 8.04193C15.2326 4.02438 11.9961 0.767822 8.00323 0.767822C4.0104 0.767822 0.768311 4.02438 0.768311 8.04193C0.768311 11.679 3.41537 14.6893 6.86878 15.2321V10.1458H5.03363V8.04193H6.86878V6.43603C6.86878 4.61191 7.94762 3.60472 9.59926 3.60472C10.3889 3.60472 11.2175 3.74461 11.2175 3.74461V5.53516H10.3055C9.41018 5.53516 9.12657 6.09471 9.12657 6.67104V8.04193H11.1341L10.8116 10.1458H9.12657V15.2321C12.5855 14.6893 15.2326 11.679 15.2326 8.04193Z"
        fill={LEGACY_COLORS.GRAY}
      />
    </svg>
  );
}

export function WhiteCircularLoader(props: IconProps) {
  const {style, width = 25, height = 32} = props;
  return (
    <svg
      width="25"
      height="32"
      viewBox="0 0 25 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 16C23 22.0751 18.0751 27 12 27C5.92487 27 1 22.0751 1 16C1 9.92487 5.92487 5 12 5C18.0751 5 23 9.92487 23 16ZM12 24C16.4183 24 20 20.4183 20 16C20 11.5817 16.4183 8 12 8C7.58172 8 4 11.5817 4 16C4 20.4183 7.58172 24 12 24Z"
        fill="#ABB0B9"
      />
      <g filter="url(#filter0_d_1028_16984)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5432 6.50694C13.5394 7.33536 12.8648 8.00386 12.0364 8.00008C10.9858 7.99528 9.94458 8.19745 8.97215 8.59505C7.99971 8.99265 7.11512 9.57789 6.36886 10.3174C5.62261 11.0568 5.02931 11.936 4.62285 12.9048C4.21638 13.8736 4.00471 14.9129 3.99991 15.9635C3.99511 17.014 4.19728 18.0552 4.59488 19.0277C4.99248 20.0001 5.57772 20.8847 6.31719 21.631C7.05666 22.3772 7.93587 22.9705 8.90463 23.377C9.87339 23.7834 10.9127 23.9951 11.9633 23.9999C12.7917 24.0037 13.4602 24.6783 13.4564 25.5067C13.4526 26.3352 12.778 27.0037 11.9496 26.9999C10.5051 26.9933 9.07598 26.7022 7.74394 26.1433C6.41189 25.5844 5.20297 24.7687 4.18621 23.7426C3.16944 22.7165 2.36473 21.5001 1.81803 20.1631C1.27133 18.826 0.993341 17.3943 0.999939 15.9498C1.00654 14.5052 1.29759 13.0761 1.85648 11.7441C2.41537 10.4121 3.23116 9.20314 4.25726 8.18637C5.28336 7.16961 6.49967 6.3649 7.83677 5.8182C9.17386 5.2715 10.6055 4.99351 12.0501 5.00011C12.8785 5.00389 13.547 5.67852 13.5432 6.50694Z"
          fill="url(#paint0_linear_1028_16984)"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1028_16984"
          x="0.999756"
          y="0"
          width="23.5435"
          height="31.9999"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="6" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.38 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1028_16984"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1028_16984"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1028_16984"
          x1="10"
          y1="6"
          x2="6"
          y2="21.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABB0B9" />
          <stop offset="1" stopColor="#ABB0B9" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function CircularLoader(props: IconProps) {
  const {style, width = 26, height = 26} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9181 11.6543C24.6615 17.6838 20.3763 23.1743 14.3468 23.9178C8.31736 24.6612 2.82683 20.376 2.0834 14.3465C1.33997 8.31706 5.62516 2.82653 11.6546 2.0831C17.6841 1.33967 23.1746 5.62486 23.9181 11.6543ZM13.9797 20.9403C18.3648 20.3996 21.4813 16.4065 20.9406 12.0214C20.3999 7.63635 16.4068 4.51987 12.0217 5.06055C7.63668 5.60123 4.52018 9.59431 5.06086 13.9794C5.60154 18.3645 9.59464 21.481 13.9797 20.9403Z"
        fill="url(#paint0_angular_1263_11230)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3708 3.38985C13.4684 4.21251 12.8807 4.95853 12.0581 5.05616C11.0148 5.17996 10.0061 5.50803 9.08966 6.02164C8.17318 6.53525 7.36686 7.22434 6.7167 8.04962C6.06654 8.87478 5.58529 9.81998 5.30044 10.8312C5.01558 11.8425 4.93268 12.8999 5.05649 13.9432C5.18027 14.9864 5.50834 15.995 6.02196 16.9115C6.53557 17.828 7.22466 18.6343 8.0499 19.2845C8.87512 19.9346 9.82033 20.4159 10.8316 20.7008C11.8428 20.9855 12.9002 21.0685 13.9435 20.9447C14.7661 20.8471 15.5121 21.4348 15.6098 22.2574C15.7074 23.0802 15.1196 23.8262 14.297 23.9238C12.8626 24.094 11.4085 23.98 10.0181 23.5883C8.62767 23.1966 7.32802 22.535 6.19333 21.641C5.05864 20.747 4.11112 19.6383 3.40492 18.3782C2.6987 17.1181 2.2476 15.7311 2.07738 14.2967C1.90716 12.8621 2.02114 11.4082 2.41283 10.0178C2.80451 8.6274 3.46623 7.3277 4.36019 6.193C5.25416 5.05832 6.36285 4.11081 7.623 3.4046C8.88314 2.69838 10.27 2.24729 11.7046 2.07706C12.5272 1.97944 13.2732 2.56719 13.3708 3.38985Z"
        fill="url(#paint1_linear_1263_11230)"
      />
      <defs>
        <radialGradient
          id="paint0_angular_1263_11230"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.0007 13.0004) rotate(78.5722) scale(6.5192)"
        >
          <stop offset="0.17933" stopColor="#404F65" />
          <stop offset="0.482278" stopColor="#404F65" />
          <stop offset="0.578139" stopColor="#30AE89" />
          <stop offset="0.939451" stopColor="#30AE89" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_1263_11230"
          x1="9.79224"
          y1="3.32031"
          x2="12.6134"
          y2="22.1163"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.291064" stopColor="#404E64" />
          <stop offset="1" stopColor="#35927F" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function RangeSliderThumb(props: IconProps) {
  const {style, width = 32, height = 32} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_388_12509)">
        <rect x="3" y="1" width="27" height="27" rx="13.5" fill="white" />
        <rect
          x="3.5"
          y="1.5"
          width="26"
          height="26"
          rx="13"
          stroke={LEGACY_COLORS.GRAY}
        />
      </g>
      <path
        d="M12.5 10V19"
        stroke={LEGACY_COLORS.GRAY_MEDIUM_DARK}
        strokeLinecap="round"
      />
      <path
        d="M16.5 10V19"
        stroke={LEGACY_COLORS.GRAY_MEDIUM_DARK}
        strokeLinecap="round"
      />
      <path
        d="M20.5 10V19"
        stroke={LEGACY_COLORS.GRAY_MEDIUM_DARK}
        strokeLinecap="round"
      />
      <defs>
        <filter
          id="filter0_d_388_12509"
          x="0"
          y="0"
          width="33"
          height="33"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.31 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_388_12509"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_388_12509"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function PlusIcon(props: IconProps) {
  const {style, width, height} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 28}
      height={height || 28}
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7V13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H13V21C13 21.5523 13.4477 22 14 22C14.5523 22 15 21.5523 15 21V15H21C21.5523 15 22 14.5523 22 14C22 13.4477 21.5523 13 21 13H15V7Z"
        fill="white"
      />
    </svg>
  );
}

export function CircleCheckIcon(props: IconProps) {
  const {width, height} = props;
  return (
    <svg
      width={width || 12}
      height={height || 12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6ZM6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM8.87629 4.32925C9.05813 4.12143 9.03707 3.80555 8.82925 3.62371C8.62143 3.44187 8.30555 3.46293 8.12371 3.67075L5.0299 7.20653L3.9 5.7C3.73431 5.47909 3.42091 5.43431 3.2 5.6C2.97909 5.76569 2.93431 6.07909 3.1 6.3L4.6 8.3C4.69046 8.42061 4.83051 8.49397 4.98117 8.49965C5.13183 8.50532 5.27701 8.44271 5.37629 8.32925L8.87629 4.32925Z"
        fill={LEGACY_COLORS.GRAY}
      />
    </svg>
  );
}

export function CloseModalIcon(props: IconProps) {
  const {style, width = 36, height = 36} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="35"
        height="35"
        rx="17.5"
        stroke="black"
        strokeOpacity="0.08"
      />
      <path
        d="M22 14L14 22M14 14L22 22"
        stroke="black"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function FiltersCheckboxChecked(props: IconProps) {
  const {color = LEGACY_COLORS.GRAY, width = 25, height = 25} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width={width - 1}
        height={height - 1}
        rx="1.5"
        fill={color}
        stroke={color}
      />
      <path
        d="M19.25 7.25L10.25 17.75L5.75 13.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FiltersCheckboxUnChecked(props: IconProps) {
  const {width = 25, height = 25} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width={width - 1}
        height={height - 1}
        rx="1.5"
        fill="white"
        stroke="#A5A5A5"
      />
    </svg>
  );
}

export function CloseDSIcon(props: IconProps) {
  const {width = 28, height = 29, color = 'black'} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28 29"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70711 6.79289C7.31658 6.40237 6.68342 6.40237 6.29289 6.79289C5.90237 7.18342 5.90237 7.81658 6.29289 8.20711L12.5858 14.5L6.29289 20.7929C5.90237 21.1834 5.90237 21.8166 6.29289 22.2071C6.68342 22.5976 7.31658 22.5976 7.70711 22.2071L14 15.9142L20.2929 22.2071C20.6834 22.5976 21.3166 22.5976 21.7071 22.2071C22.0976 21.8166 22.0976 21.1834 21.7071 20.7929L15.4142 14.5L21.7071 8.20711C22.0976 7.81658 22.0976 7.18342 21.7071 6.79289C21.3166 6.40237 20.6834 6.40237 20.2929 6.79289L14 13.0858L7.70711 6.79289Z"
        fill={color}
      />
    </svg>
  );
}
